import { render, staticRenderFns } from "./ErpExpertiseInput.vue?vue&type=template&id=33f95050&"
import script from "./ErpExpertiseInput.vue?vue&type=script&lang=js&"
export * from "./ErpExpertiseInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports